import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';

var SkeletonLoader = (_param)=> {
    var { animate =true , className , children , 'data-t': dataT = 'skeleton-loader'  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "animate",
        "className",
        "children",
        'data-t'
    ]);
    return React.createElement("div", swcHelpers.extends({
        className: classnames('skeleton-loader', {
            'skeleton-loader--animated': animate
        }, className),
        "data-t": dataT,
        "aria-busy": true
    }, rest), children);
};

export { SkeletonLoader };
//# sourceMappingURL=SkeletonLoader.js.map
